import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15903de2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "ScheduleTemplateNewButton" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-plus" }, null, -1));
const _hoisted_3 = [
    _hoisted_2
];
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { ModalBox } from '@/components/UI';
import { ScheduleTemplateForm } from '@/components/Schedule';
import { ScheduleTemplate } from '@/types/scheduleTemplates';
import useScheduleTemplates from '@/compositions/useScheduleTemplates';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const toast = useToast();
        const template = ref(ScheduleTemplate.empty());
        const editVisible = ref(false);
        const { createScheduleTemplate } = useScheduleTemplates();
        const startEdit = () => {
            template.value = ScheduleTemplate.empty();
            editVisible.value = true;
        };
        const stopEdit = () => {
            editVisible.value = false;
        };
        const createTemplate = async () => {
            const id = await createScheduleTemplate(template.value);
            if (id) {
                toast.success("Successfully created");
            }
            else {
                toast.error("Could not create Schedule Template");
            }
            editVisible.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    type: "button",
                    size: "lg",
                    class: "btn btn-danger newbutton btn-circle btn-xl",
                    onClick: _cache[0] || (_cache[0] = ($event) => (startEdit()))
                }, _hoisted_3),
                (editVisible.value)
                    ? (_openBlock(), _createBlock(_unref(ModalBox), {
                        key: 0,
                        title: "Create new schedule template",
                        size: "lg",
                        submitButtonTitle: "Save",
                        submitDisabled: !template.value.name,
                        onSubmit: _cache[2] || (_cache[2] = ($event) => (createTemplate())),
                        onClose: _cache[3] || (_cache[3] = ($event) => (stopEdit()))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(ScheduleTemplateForm), {
                                modelValue: template.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((template).value = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                    }, 8, ["submitDisabled"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
